export default "__VITE_ASSET__25ad5102__"